import { getBaseFeature } from '@/assets/style/variable'

const styObj = {
  default: {},
  kiko: {},
}

export const pageCssVars = {
  methods: {
    cssVars() {
      const base = getBaseFeature()
      const theme = this.packageName && styObj[this.packageName] ? styObj[this.packageName] : styObj.default
      return { ...base, ...theme }
    },
  },
}
